<template lang="html">
  <div>
    <v-dialog
      v-model="SettingGroupDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
      <v-card style="margin-top: 10px !important;">
        <div v-if="status_edit === 'start'" :style="stylechat">
          <v-layout row wrap justify-center align-center class="pt-5 pl-3 pr-3">
            <v-col
              cols="1"
              justify="center"
              align="start"
              class="pl-2 pr-0 pt-0 pb-0 cursor"
              @click="closeDialog"
            >
              <v-icon class="fz-30">mdi-chevron-left</v-icon>
            </v-col>
            <v-col
              cols="10"
              justify="center"
              align="center"
              class="pa-0"
            >
              <span class="tab-title">{{$t('LeftSide.header.setting')}}</span>
            </v-col>
            <v-col
              cols="1"
              justify="center"
              align="center"
              class="pr-2 pl-0 pt-0 pb-0"
              >
            </v-col>
          </v-layout>
          <v-divider class="mt-4 mb-2"></v-divider>
          <v-layout row wrap justify-center align-start class="pt-5 pl-5 pr-5 pb-2">
            <v-badge
              avatar
              bordered
              overlap
              bottom
              offset-x="25"
              offset-y="25"
            >
              <template v-slot:badge>
                <v-avatar>
                  <v-icon>mdi-camera</v-icon>
                </v-avatar>
              </template>

              <v-avatar
                size="100"
                @click="uppic"
              >
              <img v-if="SettingGroupDetail.picture" :src="SettingGroupDetail.picture" alt="" class="img-position">
              <img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
              </v-avatar>
              <div style="display: none;">
                <input type="file" name="profileuser"  @change="previewImageprofiles" accept="image/*" id="uploadpicprofileuser"/>
              </div>
            </v-badge>
          </v-layout>
          <v-divider class="mt-5 mr-3 ml-3 mb-3"></v-divider>
          <v-layout column justify-start align-start class="pt-5 pl-5 pr-5 pb-2">
            <span class="span-color">{{$t('Settings.editProfile.groupName')}}</span>
            <v-row @click="editInfor('edit-name')" class="pt-5 pl-3 pb-2 width-100" align="center">
              <b class="text-title-edit text-overflow" v-if="SettingGroupDetail.name">{{SettingGroupDetail.name}}</b>
              <b class="text-title-edit text-overflow" v-else>-</b>
              <v-spacer></v-spacer>
              <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
            </v-row>
          </v-layout>
        </div>
        <div v-if="status_edit === 'edit-name'" :style="stylechat">
          <v-layout row wrap justify-center align-center class="pt-5 pl-3 pr-3">
            <v-col
              cols="1"
              justify="center"
              align="start"
              class="pl-2 pr-0 pt-0 pb-0"
            >
            </v-col>
            <v-col
              cols="10"
              justify="center"
              align="center"
              class="pa-0"
            >
              <span class="tab-title">{{$t('Settings.editProfile.groupName')}}</span>
            </v-col>
            <v-col
              cols="1"
              justify="center"
              align="center"
              class="pr-2 pl-0 pt-0 pb-0 cursor"
              @click="editInfor('start')"
              >
              <v-icon class="fz-30">mdi-close</v-icon>
            </v-col>
          </v-layout>
          <v-divider class="mt-4 mb-2"></v-divider>
          <v-layout column justify-start align-start class="pt-2 pl-5 pr-5 pb-2">
            <v-row class="pt-5 pl-3 width-100" align="center">
              <v-text-field
                v-model="edit_name"
                ref="displayname"
                :placeholder="$t('Settings.editProfile.groupName')"
                solo
                dense
                hide-details
              ></v-text-field>
            </v-row>
            <v-row class="pl-3 pb-2 width-100" align="center">
              <!-- <span class="span-color-err pl-1 pt-2" v-if="edit_name === ''">{{$t('Homepage.Dialog.inputphoneErrorDigit')}}</span> -->
              <v-btn @click="updateName(edit_name)" :loading="loading" class="btn-confirm mt-8" block rounded :disabled="edit_name === SettingGroupDetail.name || edit_name === ''">{{$t('AnswerQuestion.update')}}</v-btn>
            </v-row>
          </v-layout>
        </div>

      </v-card>
    </v-dialog>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import WarningDialog from '@/components/Alert/Warning'
import ErrorDialog from '@/components/Alert/Error'
var _ = require('lodash')
export default {
  props: {
    SettingGroupDialog: Boolean,
    SettingGroupDetail: {}
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      loading: false,
      edit_name: '',
      status_edit: 'start',
      selectFile: '',
      selected: [],
      FriendList: [],
      ErrorDialogDetail: {},
      ErrorDialog: false,
      WarningDialogDetail: {},
      WarningDialog: false,
      data_user: {},
      edit_member: false,
      member_active: [],
      member_pending: [],
      progress: false,
      search: '',
      stylechat: {
        "--SettingGroup-HeaderColor": "white",
        "--SettingGroup-TabBackground": "white",
        "--SettingGroup-Icon": "gray",
        "--SettingGroup-IconActive": "#2662ae",
        "--SettingGroup-Background": "white",
        "--SettingGroup-FontSize": "18px",
        "--SettingGroup-FontSize-Title": "24px",
        "--SettingGroup-FontColor": "back",
        "--SettingGroup-FontSize-Status": "16px",
        "--SettingGroup-FontColor-Status": "grey",
        "--SettingGroup-Background-Input": "#E2E1E3",
        "--SettingGroup-Color-Button": "#EFF2FE",
        "--SettingGroup-FontColor-Button": "#2662ae",
        "--SettingGroup-FontColor-Block-Button": "#cb1002",
        "--SettingGroup-FontColor-Dis-Button": "#e2e1e3",
        "--SettingGroup-Btn-Confirm-Background": "#2662ae",
        "--SettingGroup-Btn-Confirm-Color": "white",
        "--SettingGroup-Btn-Confirm-FontSize": "18px",
        "--SettingGroup-Btn-Cancel-Background": "white",
        "--SettingGroup-Btn-Cancel-Color": "#2662ae",
        "--SettingGroup-Btn-Cancel-FontSize": "18px",
        "--SettingGroup-Btn-Leave-Background": "white",
        "--SettingGroup-Btn-Leave-Color": "#ff5252",
        "--SettingGroup-Btn-Leave-FontSize": "18px",
        "--SettingGroup-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    WarningDialog,
    ErrorDialog
  },
  computed: {
    FilterListFriend () {
      if (this.search !== '' && this.search !== null) {
        return this.FriendList.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.FriendList
      }
    },
  },
  watch: {
    SettingGroupDialog () {
      if (this.SettingGroupDialog) {
        // console.log(this.SettingGroupDetail)
        this.edit_name = this.SettingGroupDetail.name
        // this.member_active = _.filter(this.SettingGroupDetail.member, function (o) { return o.statemember === 'active' })
        // this.member_pending = _.filter(this.SettingGroupDetail.member, function (o) { return o.statemember === 'pending' })
        // this.getListFriend()
      }
    },
    selected () {
      // console.log(this.selected)
    }
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
  },
  methods: {
    editInfor (type) {
      this.status_edit = type
    },
    uppic () {
      document.getElementById('uploadpicprofileuser').click()
    },
    previewImageprofiles (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenuser', this.data_user.tokenuser)
      uploadFile.append('group_id', this.SettingGroupDetail.group_id)
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/setimagegroup', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.SettingGroupDetail.picture = response.data.filename
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    updateName () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/setnamegroup`, {
        group_id: this.SettingGroupDetail.group_id,
        tokenuser: this.data_user.tokenuser,
        groupname: this.edit_name
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.SettingGroupDetail.name = this.edit_name
          this.status_edit = 'start'
        }
      }).catch(err => {
        console.log(err)
        this.status_edit = 'start'
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    removeListAddGroup (item) {
      // console.log(item)
      this.selected.splice(this.selected.indexOf(item), 1)
    },
    getListFriend () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + '/v1/get-list-friend', {
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            this.progress = false
            this.FriendList = response.data['list_friend']
            this.FriendList = _.differenceBy(this.FriendList, this.member_active, 'tokenuser')
            this.FriendList = _.differenceBy(this.FriendList, this.member_pending, 'tokenuser')
          }
        // console.log(this.FriendList)
      }).catch(err => {
        console.log(err)
        this.selected = []
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    closeAlertDialog (data) {
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    emitWarning (item) {
      this.WarningDialog = false
      if (item.type === 'kickgroup') {
        this.kickGroup(item)
      } else if (item.type === 'cancelinvite') {
        this.cancelInvite(item)
      }
    },
    openDialog (item, index, type) {
      // console.log(item)
      if (type === 'kickgroup') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Right.deleteFriendGroup', {name: item.name}),
          detail: item,
          index: index,
          type: 'kickgroup'
        }
        this.WarningDialog = true
      } else if (type === 'cancelinvite') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Right.cancelInvite', {name: item.name}),
          detail: item,
          index: index,
          type: 'cancelinvite'
        }
        this.WarningDialog = true
      }
    },
    closeDialog() {
      this.selected = []
      this.search = ''
      this.member_active = []
      this.member_pending = []
      this.FriendList = []
      this.$emit('closeComponents', {
        name: 'settinggroup',
        value: false
      })
      // this.edit_member = false
    },
    editGroup (value) {
      this.edit_member = value
    }
  },
}
</script>

<style lang="css" scoped>
.cursor {
  cursor: pointer;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--SettingGroup-FontSize-Title) !important;
  color: var(--SettingGroup-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--SettingGroup-FontSize-Title-Edit) !important;
  color: var(--SettingGroup-FontColor) !important;
}
.tab-title {
  color: var(--SettingGroup-FontColor) !important;
  font-size: var(--SettingGroup-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--SettingGroup-FontColor-Status) !important;
  font-size: var(--SettingGroup-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.checkbox-color {
  color: var(--SettingGroup-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 120px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--SettingGroup-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--SettingGroup-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--SettingGroup-Icon) !important;
}
.icon-color {
  color: var(--SettingGroup-IconActive) !important;
}
.btn-confirm {
  background-color: var(--SettingGroup-Btn-Confirm-Background) !important;
  color: var(--SettingGroup-Btn-Confirm-Color) !important;
  font-size: var(--SettingGroup-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--SettingGroup-Btn-Cancel-Background) !important;
  color: var(--SettingGroup-Btn-Cancel-Color) !important;
  font-size: var(--SettingGroup-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--SettingGroup-Btn-Leave-Background) !important;
  color: var(--SettingGroup-Btn-Leave-Color) !important;
  font-size: var(--SettingGroup-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--SettingGroup-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--SettingGroup-FontSize-Title) !important;
  color: var(--SettingGroup-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--SettingGroup-FontColor) !important;
  font-size: var(--SettingGroup-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--SettingGroup-FontColor-Status) !important;
  font-size: var(--SettingGroup-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
